export default __webpack_public_path__ + "static/product-unit-3-pencil-e10894b4cc665861e33f962f895745c5.png";